export default "__VITE_ASSET__CAvqJXTq__"